import type { ColDef, ITooltipParams } from "ag-grid-enterprise";
import { ONE_LINE_CELL_CLASS } from "./OneLineCells";

/** Row and header height of every master list grid (Products is the reference). */
export const LIST_ROW_HEIGHT = 28;
export const LIST_HEADER_HEIGHT = 32;

const textTooltip = (params: ITooltipParams) => {
	const text = params.valueFormatted ?? params.value;
	return typeof text === "string" && text !== "" ? text : undefined;
};

/**
 * One line per row on top of the grid's own defaults: the global default wraps text and lets the
 * delete button grow the row. A value that does not fit is cut with an ellipsis and shown whole in
 * a browser tooltip, so the grid needs `enableBrowserTooltips` and `<OneLineCellStyles />`.
 */
export const listColDef = <T>(base: ColDef<T>): ColDef<T> => ({
	...base,
	wrapText: false,
	autoHeight: false,
	cellClass: ONE_LINE_CELL_CLASS,
	tooltipValueGetter: textTooltip,
});
